import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'pcs-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ButtonGroupComponent {

  @HostBinding('class.btn-group') rootClasses = true;

  @HostBinding('class.btn-group-rounded')
  @Input() btnrounded = false;

}
